import { Chip, type ChipVariant } from './Chip'
import type { ComponentProps } from 'react'

// KlimbBadge is a thin adapter over `<Chip tone="mono">` — it renders
// the small monospace tag used in slide chrome and area shells.
//
// Variants describe the *role* of the badge in the chrome (default tag,
// accent emphasis, "Public"-surface marker, "Internal"-surface marker)
// rather than the original scaffold colors (`primary | success | danger`),
// which were dropped when the brand palette moved to semantic tokens.
// For full control over color + tone, reach for `<Chip>` directly.
export type KlimbBadgeVariant = 'default' | 'accent' | 'public' | 'internal'

export interface KlimbBadgeProps extends Omit<ComponentProps<typeof Chip>, 'variant' | 'tone'> {
  variant?: KlimbBadgeVariant
}

const TO_CHIP_VARIANT: Record<KlimbBadgeVariant, ChipVariant> = {
  default: 'default',
  accent: 'accent',
  public: 'default',
  internal: 'default',
}

export function KlimbBadge({ variant = 'default', ...rest }: KlimbBadgeProps) {
  return <Chip tone="mono" variant={TO_CHIP_VARIANT[variant]} {...rest} />
}
